import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface TestimonialProps {
  author: string;
  authorSubtitle?: string;
  content: string;
  rating?: number;
}

export function Testimonial(props: TestimonialProps) {
  return (
    <Card variant="outlined" sx={{ height: 1 }}>
      <Stack
        component={CardContent}
        // justifyContent="space-between"
        height={1}
        gap={2}
      >
        <Box>
          <Typography variant="body1">{props.author}</Typography>
          <Typography variant="body2" color="text.secondary">
            {props.authorSubtitle}
          </Typography>
        </Box>
        {!!props.rating && <Rating value={props.rating} readOnly />}

        <Typography variant="body1" color="text.secondary" gutterBottom>
          {props.content}
        </Typography>
      </Stack>
    </Card>
  );
}

export default Testimonial;
